import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TFunction } from 'i18next';

import AboutDialog from '@talend/react-components/lib/AboutDialog';

import { I18N_NAME_SPACE } from '../../../../constants';
import { Versions } from '../../service/AboutModal.types';

interface FrontendPackage {
	name: string;
	version: string;
}

const mapBackendServices = (services: Versions, t: TFunction) => (serviceKey: string) => ({
	version: services[serviceKey],
	name: serviceKey,
	build: t('ABOUT_MODAL_NOT_APPLICABLE', 'NA'),
});

function getAllServices(services: Versions, t: TFunction) {
	const inventoryService = {
		name: 'Data-Inventory-Webapp',
		version: TALEND_APP_INFO.version,
		build: TALEND_APP_INFO.revision,
	};

	return Object.keys(services)
		.map(mapBackendServices(services, t))
		.concat(
			inventoryService,
			TALEND_APP_INFO.talendLibraries.filter(({ name }: FrontendPackage) =>
				name.includes('talend'),
			),
		);
}

export interface AboutModalMapProps {
	show: boolean;
	backendServices: Versions;
}

export interface AboutModalDispatchProps {
	onHide: Function;
	fetchServices: Function;
}

export type AboutModalProps = AboutModalMapProps & AboutModalDispatchProps;

export function AboutModal({ show, onHide, backendServices, fetchServices }: AboutModalProps) {
	const { t } = useTranslation(I18N_NAME_SPACE);
	const [expanded, setExpanded] = useState(false);
	const { name, version } = AboutDialog.Table.getColumnHeaders();

	useEffect(() => {
		if (show && Object.keys(backendServices).length === 0) {
			fetchServices();
		}
	}, [show, backendServices, fetchServices]);

	return (
		<AboutDialog
			definition={[name, version]}
			show={show}
			expanded={expanded}
			onHide={onHide}
			icon="talend-tdc-negative"
			product="Data Inventory"
			services={getAllServices(backendServices, t)}
			onToggle={() => setExpanded(!expanded)}
		/>
	);
}
